import React from 'react';

export default function IframeForm ({ formEmbedCode }) {
  return <div id='iframe-form' data-testid='iframe-form' dangerouslySetInnerHTML={{ __html: formEmbedCode }}/>;
}
